import React from 'react';
const DataGlobal = React.createContext("data");
export default DataGlobal;